import { FC, memo, useCallback } from "react";
import { Typography, FormControlLabel } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { StyledRadioGroup, StyledRadio } from "../styled";
import { useSettings } from "@framework/provider-settings";

export const ColumnCountSelector: FC = memo(() => {
  const { getSchemeColumnCount, setSchemeColumnCount } = useSettings();

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setSchemeColumnCount(event.target.value);
    },
    [setSchemeColumnCount],
  );

  return (
    <>
      <Typography variant="h6" gutterBottom>
        <FormattedMessage id={"pages.profile.titleSchemeColumnCount"} />
      </Typography>
      <StyledRadioGroup row name="schemeColumnCount" value={getSchemeColumnCount()} onChange={handleChange}>
        {[1, 2, 3, 4].map(value => (
          <FormControlLabel
            key={value}
            value={String(value)}
            control={<StyledRadio name="schemeColumnCount" />}
            label={String(value)}
          />
        ))}
      </StyledRadioGroup>
      <Typography variant="caption" color="textSecondary" sx={{ mt: 1 }}>
        <FormattedMessage id={"pages.profile.autoApplyHint"} />
      </Typography>
    </>
  );
});
